import * as React from 'react';

// tslint:disable:max-line-length
export const FullScreenIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <path
      d="M8.795 1h5.81A2.397 2.397 0 0 1 17 3.395v5.81M9.205 17h-5.81A2.397 2.397 0 0 1 1 14.605V8.8"
      fill="none"
      fillRule="evenodd"
      stroke="#FFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    ></path>
  </svg>
);
